module.exports = __webpack_public_path__ + "img/q6.ded76c0d.jpeg";